/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BatchType {
    CHARGEBACK = 'Chargeback',
    ACHRETURN = 'ACHReturn',
}